import Vue from 'vue'
import HighchartsVue from 'highcharts-vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify';
import TVSMService from '@/plugins/tvsm-service'
import router from '@/router'
import moment from 'moment-timezone'

import 'moment/locale/ko'
import 'moment/locale/en-in'
import 'moment/locale/es'

import './css/icon-font-style.css'

Vue.config.productionTip = false
Vue.use(require('vue-moment'), {moment})
Vue.use(HighchartsVue)
Vue.use(TVSMService)

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
